/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, InputSelect, Label, Modal, CustomLoading, Input, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { changeModal } from "../../../../Redux/Actions";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, 
    ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn} from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ListPartCommandsVariablesAcceptValues = () => {
    const { t } = useTranslation();

    document.title = "Valores aceitos";
    const Services = useRef(new PartsComandServices());
    const [partCommands, setPartCommands] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [parts, setParts] = useState([]);

    const partCommandField = useRef();
    const nameField = useRef();
    const ValueField = useRef();
    const abbreviationField = useRef();

    const partCommandValue = useRef();
    const nameValue = useRef();
    const customValue = useRef();
    const abbreviationValue = useRef();

    useEffect(() => {
        async function getValues(){
            let currentList = await Services.current.getPartsCommandsVariablesAcceptValues();
            setPartCommands(currentList)
            setIsLoading(false)
        }

        async function getPartCommand(){
            let currentItem = await Services.current.getPartCommandsVariables();
            setParts(currentItem);
        }

        getValues();
        getPartCommand();
    },[])

    // Salva as edições do usuário
    async function Save(){
        store.dispatch(changeModal(''))
        if(isValidField(partCommandValue.current) && isValidField(nameValue.current) && isValidField(abbreviationValue.current)){

            let form = new FormData();
            if(partCommandValue.current){form.append('command_variable', partCommandValue.current)}
            if(customValue.current){form.append('value', customValue.current)}
            if(nameValue.current){form.append('name', nameValue.current)}
            if(abbreviationValue.current){form.append('abbreviation', abbreviationValue.current)}

    
            await Services.current.SavePartCommandVariableAcceptValue(form)
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return(
        <>
            <Container>
                <PageTitle>
                    Valores aceitos
                </PageTitle>

                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + partCommands.length + " Valores" }
                    </CountContainer>

                    <Button onClick={()=>store.dispatch(changeModal('newPartCommand'))} width={'fit-content'} color={'green'} icon={''} text={"+ Criar Novo valor"}></Button>
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>Nome</TitleText>
                        <TitleText>Variável</TitleText>
                    </LineTitle>

                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        partCommands?.map((item, index)=>(
                            <LineList key={index} href={`/PartCommandsVariablesAcceptValues/${item.id}`}>
                                <ListText>{item.name}</ListText>
                                <ListText>{item.command_variable_name}</ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>
            </Container>
            
            <Modal title={"Cadastrar Valor"} name={'newPartCommand'} width={'70%'} height={'90%'} >
                
                <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                    <ContainerColumn>
                        <Label text={"Variável"} aling="flex-start"/>
                        <InputSelect
                            key={'variable'}
                            name={'variable'}
                            id={'variable'}
                            placeholder={"Variável"}
                            invalidMessage = {"Variável!"}
                            options={parts}
                            innerRef={partCommandField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => partCommandValue.current = value}>
                        </InputSelect>      

                        <Label text={"Nome"} aling="flex-start"/>
                        <Input
                            key={'name'}
                            name={'name'}
                            id={'name'}
                            placeholder={"Nome"}
                            invalidMessage = {"Nome inválida!"}
                            innerRef={nameField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => nameValue.current = value}>
                        </Input>                
                    </ContainerColumn>

                    <ContainerColumn>
                        <Label text={"Valor"} aling="flex-start"/>
                        <Input
                            key={'value'}
                            name={'value'}
                            id={'value'}
                            type={'Number'}
                            placeholder={"Valor"}
                            invalidMessage = {"Valor inválida!"}
                            innerRef={ValueField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => customValue.current = value}>
                        </Input>

                        <Label text={"Abreviação"} aling="flex-start"/>
                        <Input
                            key={'abbreviation'}
                            name={'abbreviation'}
                            id={'abbreviation'}
                            type={'text'}
                            placeholder={"Abreviação"}
                            invalidMessage = {"Abreviação inválida!"}
                            innerRef={abbreviationField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => abbreviationValue.current = value}>
                        </Input>

                    </ContainerColumn>
                </ContainerRow>

                
                <ButtonsContainer>
                    <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                    <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={()=>store.dispatch(changeModal(''))}/>
                </ButtonsContainer>
            </Modal>
        </>
    )
}

export default ListPartCommandsVariablesAcceptValues;